<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-calculator'"></top-line>
    <el-row class="pagebody">
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="20">
                <el-form-item label="资源类型名称：" prop="name" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.name" style="width:175px" />
                </el-form-item>
                <el-form-item label="状态:" prop="status" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.status" placeholder="请选择状态" style="width: 175px">
                    <el-option label="全部状态" value=""></el-option>
                    <el-option label="有效" value="0"></el-option>
                    <el-option label="无效" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <div class="action-buttons-right">
                  <el-button type="success" icon="el-icon-plus" size="small" plain
                    @click="handleCreate">
                    新增
                  </el-button>
                  <el-button type="primary" icon="el-icon-search" size="small" plain
                    @click="handleSearch">
                    查询
                  </el-button>
                  <el-button type="info" icon="el-icon-refresh-left" size="small" plain
                    @click="handleReset">
                    重置
                  </el-button>
                </div>
              </el-col>

            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <el-row class="main-table">
          <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%"
          >
            <!-- 算力类型ID -->
            <el-table-column fixed prop="id" label="ID" width="80" />
            <!-- 资源类型名称 -->
            <el-table-column  prop="name" label="资源类型名称" width="150" />
            <!-- 状态列 -->
            <el-table-column prop="status" label="状态">
              <template v-slot="scope">
                 <el-tag :type="getformatStatus(scope.row.status)">
                  {{ formatStatus(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 备注 -->
            <el-table-column prop="remark" label="备注" />
            <!-- 父ID -->
            <!-- <el-table-column prop="p_id" label="父ID" width="80" /> -->
            <!-- 创建时间 -->
            <el-table-column label="创建时间" >
              <template v-slot="scope">
                {{ formatDateTime(scope.row.created_at) }}
              </template>
            </el-table-column>
            <!-- 创建人 -->
            <el-table-column prop="created_by" label="创建人" />
            <!-- 更新时间 -->
            <el-table-column label="更新时间" >
              <template v-slot="scope">
                {{ formatDateTime(scope.row.updated_at) }}
              </template>
            </el-table-column>
            <!-- 更新人 -->
            <el-table-column prop="updated_by" label="更新人" />
          <el-table-column fixed="right" header-align="center" align="center" show-overflow-tooltip  label="操作">
          <template v-slot="scope">
            <el-button
              type="text"
              size="mini"
              @click="showDetails(scope.row)">详情</el-button>
              <el-button
              type="text"
              size="mini"
              @click="editComputeType(scope.row)">编辑</el-button>
              <el-button
              type="text"
              size="mini"
              @click="delComputeType(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>
    <!-- 引入 CreateComputeType 组件 -->
    <create-compute-type ref="createComputeType" @success="getTableData"></create-compute-type>
     <!-- 编辑组件 -->
    <edit-compute-type ref="editComputeType" @success="getTableData"></edit-compute-type>
  </d2-container>
</template>
<script>
import CreateComputeType from './CreateComputeType.vue';
import EditComputeType from './EditComputeType.vue';
import topLine from "@/components/save-common/topLine.vue";
import { MessageBox } from 'element-ui';

export default {
  name: "computeTypes",
  components: {
    topLine,
    CreateComputeType,
    EditComputeType,
  },
  mounted () {
    this.loadParams();
  },
  data() {
    return {
      pageTitle: "资源类型",
      labelWidth: '120px',
      tableDataApi: '/api-30216/api/compute-types',
      searchForm: {
        name: '',
        status: '',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        pageSizeList: [10, 20, 50, 100],
        total: 0,
      },
      tableData: [],
    }
  },
  methods: {
    // 格式化状态
    formatStatus(value) {
      const map = {
        0: '有效',
        1: '无效',
      };
      return map[value] || '-';
    },
    getformatStatus(value) {
      switch (value) {
        case 0:
          return 'success';
        case 1:
          return 'danger';
        default:
          return 'info';
      }
    },

    // 格式化日期时间
    formatDateTime(datetime) {
      if (!datetime) return '';
      
      const date = new Date(datetime);
      if (isNaN(date.getTime())) return '';
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    loadParams() {
      if(this.$route.query.page) {
        this.pagination.page = parseInt(this.$route.query.page, 10);
      }
      if(this.$route.query.pageSize) {
        this.pagination.pageSize = parseInt(this.$route.query.pageSize, 10);
      }
      // 根据新的分页参数重新加载数据
      this.getTableData();
    },
    handleReset() {
      this.searchForm = {
        name: '',
        status: '',
        page: 1,
        pageSize: 10,
      };
      this.getTableData();
    },
    //查询
    handleSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.getTableData();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getTableData();
    },

    // 详情
    showDetails(row) {
      this.$router.push({
        path: '/computeTypeDetails',
        query: {
          id: row.id,
          page: this.pagination.page,       // 当前页码
          pageSize: this.pagination.pageSize, // 页面大小
        }
      })
    },
    // 新增弹窗
    handleCreate() {
      this.$refs.createComputeType.openDialog();
    },

    // 编辑弹窗
    editComputeType(row) {
      this.$refs.editComputeType.openDialog(row);
    },
    getTableData() {
      this.$axios.get(this.tableDataApi, {
      params: {
        name: this.searchForm.name,
        status: this.searchForm.status,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
      }
      }).then(response => {
        console.log(response);
        this.tableData = response.data || [];
        this.pagination.total = response.total || 0;
      });
    },

    // 删除
    delComputeType(row) {
      MessageBox.confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         this.$axios.delete(`/api-30216/api/compute-types/${row.id}`).then(response => {
          if (response.code === 200) {
            this.$message.success(response.message || '删除成功');
          } else {
            this.$message.error(response.message || '删除失败');
          }
          this.getTableData();
        }).catch(error => {
          console.error(error);
          this.$message.error('删除失败，请检查网络或服务状态');
        });
      }).catch(() => {
        // 用户点击“取消”或关闭弹窗时触发
        this.$message.info('已取消删除');
      });
    },
  }

}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}

.action-buttons-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}

.action-buttons-right .el-button {
  margin-left: 0 !important;
}
</style>